import { render, staticRenderFns } from "./LeadList.vue?vue&type=template&id=bced03ae&scoped=true"
import script from "./LeadList.vue?vue&type=script&lang=js"
export * from "./LeadList.vue?vue&type=script&lang=js"
import style0 from "./LeadList.vue?vue&type=style&index=0&id=bced03ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bced03ae",
  null
  
)

export default component.exports